/**
 * CustomFieldCell — renders a single custom field value in a list-view cell.
 *
 * Keeps formatting concerns (booleans → ✓/—, selects → Badge, dates → locale)
 * out of list pages so each page stays lean.
 */
import React from 'react';
import { Badge } from '../ui/badge';

const CustomFieldCell = ({ field, value }) => {
  if (value === null || value === undefined || value === '') {
    return <span className="text-gray-400">—</span>;
  }

  switch (field.fieldtype) {
    case 'boolean':
      return value ? (
        <span className="text-green-600 font-medium">✓</span>
      ) : (
        <span className="text-gray-400">—</span>
      );
    case 'select':
      return <Badge variant="outline">{String(value)}</Badge>;
    case 'date':
      try {
        return <span>{new Date(value).toLocaleDateString()}</span>;
      } catch {
        return <span>{String(value)}</span>;
      }
    case 'number':
      return <span className="font-mono text-sm">{value}</span>;
    case 'textarea':
      return (
        <span className="line-clamp-2 text-sm text-gray-700">
          {String(value)}
        </span>
      );
    case 'text':
    default:
      return <span>{String(value)}</span>;
  }
};

export default CustomFieldCell;
